<mat-toolbar color="primary" class="app-toolbar">
  <img src="assets/tco-logo.svg" alt="TCO logo" class="tco-logo" />
  <span class="toolbar-title">Bidding Platform</span>
  <span class="spacer"></span>
  <div class="auth-area" role="status" aria-live="polite">
    <ng-container *ngIf="authService.isLoading(); else authContent">
      <span class="auth-loading">Signing you in…</span>
    </ng-container>

    <ng-template #authContent>
      <ng-container *ngIf="authService.isSignedIn(); else authStatus">
        <div class="user-info">
          <button class="user-name-button" [matMenuTriggerFor]="userMenu" [title]="'Signed in as ' + authService.userName()">
            <span class="user-name">
              {{ authService.userName() || 'Signed in' }}
            </span>
            <mat-icon class="dropdown-icon">arrow_drop_down</mat-icon>
          </button>
          <div class="user-roles" *ngIf="authService.roles().length > 0">
            <span class="role-badge" *ngFor="let role of authService.roles()" [title]="'Role: ' + getRoleDisplayName(role)">
              {{ getRoleDisplayName(role) }}
            </span>
          </div>
        </div>
        <mat-menu #userMenu="matMenu" xPosition="before" class="user-dropdown-menu">
          <button mat-menu-item (click)="logout()" class="logout-menu-item">
            <mat-icon>logout</mat-icon>
            <span>Sign Out</span>
          </button>
        </mat-menu>
      </ng-container>

      <ng-template #authStatus>
        <ng-container *ngIf="authService.error(); else signingIn">
          <span class="auth-error">
            <span class="auth-error-message">We couldn't sign you in.</span>
            <a routerLink="/sign-in-failed" class="auth-error-link">Get help</a>
          </span>
        </ng-container>

        <ng-template #signingIn>
          <span class="auth-loading">Preparing your workspace…</span>
        </ng-template>
      </ng-template>
    </ng-template>
  </div>
</mat-toolbar>
